import React from 'react';

import t from '../../../labels/labelling-utils';
import { MatchStatusType } from '../../../typings/match';
import { IReferee } from '../../../typings/player';
import { FORMATIONS } from '../../../typings/report-tabs';
import { ITeamTypings } from '../../../typings/team';
import { makeClassNames } from '../../../utils/styles';
import ReportTabsPanel from '../../molecules/report-tabs-panel/report-tabs-panel';
import TeamsTabs from '../../molecules/teams-tabs/teams-tabs';

import { exchangeOwnGoals, getCourtesyMessage, isValidStartingLineUp } from './match-formations-helpers';

import './match-formations.scss';

export interface IMatchFormationsDataTeam {
  matchId?: string | null; // FIXME: BE sends this PROP (always? mandatory?)
  home: ITeamTypings;
  away: ITeamTypings;
  status: MatchStatusType;
  referees: IReferee[];
}

export interface IMatchFormations {
  matchFormations: IMatchFormationsDataTeam;
}

const classNames = () =>
  makeClassNames({
    MatchFormations: 'match-formations',
    formationTableWrapper: 'match-formations__table-wrapper',
    formationTables: 'match-formations__tables',
  });

const MatchFormations = ({ matchFormations }: IMatchFormations) => {
  const cn = classNames();
  const matchLineups: IMatchFormationsDataTeam = exchangeOwnGoals(matchFormations); // This is the FIX for the AUTOGOAL scorers issue

  return (
    <div className={cn.MatchFormations}>
      <TeamsTabs
        idHome={matchLineups.home.name}
        idAway={matchLineups.away.name}
        home={matchLineups.home}
        away={matchLineups.away}
        roundLabel={t('match.statistics.label.vs')}
      />
      {
        /* istanbul ignore next: unsupported optional chaining */ isValidStartingLineUp(
          matchLineups.home.playerList?.startingLineup
        ) && isValidStartingLineUp(matchLineups.away.playerList?.startingLineup) ? (
          <div className={cn.formationTables} data-panels>
            <ReportTabsPanel
              home={matchLineups.home}
              away={matchLineups.away}
              referees={matchLineups.referees}
              panelVariant={FORMATIONS}
              status={matchLineups.status}
            />
          </div>
        ) : (
          <div className={cn.formationTableWrapper}>{getCourtesyMessage()}</div>
        )
      }
    </div>
  );
};

export default MatchFormations;
